import * as THREE from 'three'

import BaseTool from '@glass-designer/tools/baseTool'

import DraggingObject from '@glass-designer/objects/draggingObject'

import GlassDesignerTypes from '@glass-designer/types'
import GlassPanelItem from '../../model/glassPanelItem'
import GlassBaseHole from '../../model/glassBaseHole'
import GlassShape from '../../model/glassShape'


// Item Move Tool
// Tool used when user clicked & dragged on a move button for a panel item / center cutout / shape
export default class ItemMoveTool extends BaseTool {
  constructor(editor) {
    super(editor)

    this.type = GlassDesignerTypes.ToolTypes.itemMoveTool
    this.moveDirection = new THREE.Vector2(0, 0)
    this.moveStartPosition = new THREE.Vector2(0, 0)

    this.selectedShape = null
    this.selectedItemList = []

    this.draggingObj = new DraggingObject(this.editor)
    this.draggingObj.setVisible(false)
    this.addChildObject(this.draggingObj)
  }


  // Tool Active
  // Called when the tool is active
  onToolActive(options = {}) {
    super.onToolActive()

    let moveHandle = this.editor.getMoveHandleObject()
    let handlePos = moveHandle.getPosition()

    this.selectedShape = null
    this.selectedItemList = []

    let selectedList = this.editor.getSelected()
    selectedList.forEach(selectedObj => {
      if(this.selectedItemList.find(curObj => curObj.object.id == selectedObj.id) != null)
        return

      // Cannot move objects from different parents
      if(this.selectedShape && selectedObj.parentObject) {
        if(this.selectedShape.id != selectedObj.parentObject.id)
          return
      }

      if (selectedObj instanceof GlassPanelItem) {
        this.selectedItemList.push({
          object: selectedObj,
          offset: selectedObj.worldPoint.clone().sub(handlePos)
        })
        this.selectedShape = selectedObj.parentObject
      }
      else if (selectedObj instanceof GlassBaseHole) {
        this.selectedItemList.push({
          object: selectedObj,
          offset: selectedObj.worldPoint.clone().sub(handlePos)
        })
        this.selectedShape = selectedObj.parentObject
      }
      else if (selectedObj instanceof GlassShape) {
        let shapeBounds = selectedObj.calculateSegmentBounds()

        this.selectedItemList.push({
          object: selectedObj,
          offset: shapeBounds.getCenter(new THREE.Vector2()).clone().sub(handlePos)
        })
        this.selectedShape = selectedObj
      }
    })

    if(this.selectedItemList.length == 0)
      return

    this.draggingObj.clearSegmentListGroups()
    this.selectedItemList.forEach(itemInfo => {
      if (itemInfo.object instanceof GlassPanelItem)
        this.draggingObj.addRectangleGroup(itemInfo.offset, itemInfo.object.width, itemInfo.object.height)
      else if(itemInfo.object instanceof GlassBaseHole)
        this.draggingObj.addSegmentListGroup(itemInfo.object.worldPoint.clone().negate().add(itemInfo.offset), itemInfo.object.segmentList)
      else if(itemInfo.object instanceof GlassShape) {
        let shapeBounds = itemInfo.object.calculateSegmentBounds()
        this.draggingObj.addSegmentListGroup(shapeBounds.getCenter(new THREE.Vector2()).clone().negate().add(itemInfo.offset), itemInfo.object.segmentList)
      }
    })
    this.draggingObj.setVisible(true)
    this.draggingObj.setPosition(handlePos)
    
    moveHandle.setupHandles({
      moveAllEnabled: true
    })
    this.moveStartPosition.copy(handlePos)

    moveHandle.setPosition(handlePos)
    moveHandle.setVisible(true)
  }

  // Tool Inactive
  // Called when the tool is no longer active
  onToolInactive() {
    super.onToolInactive()

    this.draggingObj.setVisible(false)
  }

  moveShapeObjects(applyItemMove, position) {
    
    if(applyItemMove) {
      try {
        this.editor.startUndoGroup('Moving objects')
        this.editor.addUndoShape(this.selectedShape)

        this.selectedItemList.forEach(selectedInfo => {
          let object = selectedInfo.object

          let newPosition = position.clone().add(selectedInfo.offset)

          if(object instanceof GlassPanelItem)
            this.selectedShape.movePanelItem(object, newPosition)
          else if(object instanceof GlassBaseHole)
            this.selectedShape.moveCenterCutout(object, newPosition)
          else if(object instanceof GlassShape) {
            let bounds = object.calculateSegmentBounds()
            this.selectedShape.moveShape(newPosition.sub(bounds.getCenter(new THREE.Vector2())))
          }
        })

        this.editor.onShapeUpdated(this.selectedShape)

        this.editor.closeCurrentUndoGroup()
      } catch(err) {
        // Close & undo the actions
        this.editor.closeCurrentUndoGroup()
        this.editor.undoLastAction()

        throw err
      }
    }
  }

  onReceiveObjectEvent(object, eventType, data) {
    let moveHandle = this.editor.getMoveHandleObject()
    
    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectMoved) {
      if(object == moveHandle) {
        this.draggingObj.setPosition(moveHandle.position)

        // Move objects
        this.moveShapeObjects(false, moveHandle.position)
      }
    }
    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectReleased) {
      if(object == moveHandle) {
        try {
          this.moveShapeObjects(true, moveHandle.position)
        } catch(err) {
          this.editor.component.errorMessage('Error moving objects', err.message)
        }

        this.closeTool()
      }
    }
  }
}
